import React from 'react';
import { Checkbox, Divider, Form, Icon, Segment, Grid } from 'semantic-ui-react';
import { useTranslation, Trans } from 'react-i18next';

import PropTypes from 'prop-types';

export default function RateSelector({ ratesAndGroups, rateClicked, setRateClicked, groupClicked, setGroupClicked, form, setForm }) {
    const { t } = useTranslation();
    const [displayAllRates, setDisplayAllRates] = React.useState(false);

    const groupMapping = groups => {
        if (!groups) {
            return null;
        }

        return groups.map(group => {
            if (!group.rates) {
                return null;
            }

            return (
                <Grid key={group.id}>
                    <Grid.Row style={{ marginLeft: '1em' }}>
                        <Checkbox
                            checked={group.isChecked}
                            value={group.id}
                            onChange={onClickGroupRates}
                            label={group.name ? group.name : group.group_template ? group.group_template.name : ''}
                        />
                    </Grid.Row>
                    {group.rates &&
                        group.rates.map(rate => (
                            <Grid.Row key={rate.id} style={{ marginLeft: '3em' }}>
                                <Checkbox
                                    key={rate.id}
                                    checked={rate.isChecked}
                                    value={rate.id}
                                    group={group.id}
                                    onChange={onClickRate}
                                    label={`${rate.resolved_name || ''} - ${rate.resolved_price || ''}`}
                                />
                            </Grid.Row>
                        ))}
                    <Divider fitted style={{ marginBottom: '0px', marginTop: '0px' }} />
                </Grid>
            );
        });
    };

    // RATES
    const onClickRate = (e, data) => {
        let rateArray = null;
        let rate = null;
        let groupArray = null;

        // Case rate without group clicked
        if (!data.group) {
            // looking for id of rate in rate clicked (to know if it's already checked)
            rateArray = rateClicked.findIndex(id => id === data.value);
            rate = ratesAndGroups.rates.find(rate => rate.id === data.value);
        }

        // Case rate clicked in group
        if (data.group) {
            // looking for id of rate in rate clicked (to know if it's already checked)
            rateArray = rateClicked.findIndex(id => id === data.value);
            groupArray = ratesAndGroups.groups.find(group => group.id === data.group);
            rate = groupArray.rates.find(rate => rate.id === data.value);
        }

        let tmpRateClicked = [...rateClicked];
        let tmpGroupClicked = [...groupClicked];

        // Delete case
        if (rateArray >= 0) {
            tmpRateClicked.splice(rateArray, 1);
            // modify object
            rate.isChecked = false;

            if (groupArray) {
                tmpGroupClicked.splice(groupArray, 1);
                groupArray.isChecked = false;
            }

            if (form.allRates) {
                setForm({ ...form, allRates: false });
            }
        }

        if (rateArray < 0) {
            tmpRateClicked.push(data.value);
            // modify object
            rate.isChecked = true;
        }

        // Check if all rates are checked
        if (groupArray) {
            let allGroupChecked = true;
            for (let rate of groupArray.rates) {
                let isChecked = tmpRateClicked.findIndex(id => id === rate.id);
                if (isChecked < 0) {
                    allGroupChecked = false;
                }
            }

            if (allGroupChecked) {
                tmpGroupClicked.push(groupArray.id);
                groupArray.isChecked = true;
            }
        }

        setRateClicked(tmpRateClicked);
        setGroupClicked(tmpGroupClicked);
    };

    const onClickGroupRates = (e, data) => {
        let groupArray = groupClicked.findIndex(id => id === data.value);
        let group = ratesAndGroups.groups.find(group => group.id === data.value);
        // Delete case (already checked)
        if (groupArray >= 0) {
            let tmpGroupClicked = [...groupClicked];
            tmpGroupClicked.splice(groupArray, 1);
            setGroupClicked(tmpGroupClicked);

            group.isChecked = false;

            let tmpRateClicked = [...rateClicked];
            for (let rate of group.rates) {
                let rateArray = tmpRateClicked.findIndex(id => id === rate.id);

                // Already checked case :
                if (rateArray >= 0) {
                    tmpRateClicked.splice(rateArray, 1);

                    rate.isChecked = false;
                }
            }

            if (form.allRates) {
                setForm({ ...form, allRates: false });
            }
            setRateClicked(tmpRateClicked);
        }

        // Add case
        if (groupArray < 0) {
            let newGroupClicked = groupClicked;
            newGroupClicked.push(data.value);
            setGroupClicked(newGroupClicked);

            group.isChecked = true;

            let tmpRateClicked = [...rateClicked];

            for (let rate of group.rates) {
                let rateArray = rateClicked.findIndex(id => id === rate.id);

                // Already checked case :
                if (rateArray < 0) {
                    tmpRateClicked.push(rate.id);
                    rate.isChecked = true;
                }
            }
            setRateClicked(tmpRateClicked);
        }
    };

    const selectAllButton = (ratesAndGroups, form, setForm, groupClicked, setGroupClicked, ratesClicked, setRatesClicked) => {
        return (
            <Segment>
                <Grid>
                    <Grid.Row style={{ marginLeft: '1em' }}>
                        <Form.Field>
                            <Checkbox
                                checked={form.allRates}
                                onChange={() => {
                                    let tmpGroupClicked = [...groupClicked];
                                    let tmpRatesClicked = [...ratesClicked];

                                    // Deselect All
                                    if (form.allRates) {
                                        setForm({ ...form, allRates: false });

                                        if (ratesAndGroups.groups) {
                                            // Iteration Group :
                                            for (let group of ratesAndGroups.groups) {
                                                let groupIsClicked = tmpGroupClicked.findIndex(id => id === group.id);
                                                if (groupIsClicked >= 0) {
                                                    tmpGroupClicked.splice(groupIsClicked, 1);
                                                    group.isChecked = false;
                                                }

                                                if (group.rates) {
                                                    for (let rate of group.rates) {
                                                        let rateIsClicked = tmpRatesClicked.findIndex(id => id === rate.id);
                                                        if (rateIsClicked >= 0) {
                                                            tmpRatesClicked.splice(rateIsClicked, 1);
                                                            rate.isChecked = false;
                                                        }
                                                    }
                                                }
                                            }
                                        }

                                        if (ratesAndGroups.rates) {
                                            // Iteration rates
                                            for (let rate of ratesAndGroups.rates) {
                                                let rateIsClicked = tmpRatesClicked.findIndex(id => id === rate.id);
                                                if (rateIsClicked >= 0) {
                                                    tmpRatesClicked.splice(rateIsClicked, 1);
                                                    rate.isChecked = false;
                                                }
                                            }
                                        }
                                    }

                                    // Select all
                                    if (!form.allRates) {
                                        setForm({ ...form, allRates: true });

                                        if (ratesAndGroups.groups) {
                                            // Iteration Group :
                                            for (let group of ratesAndGroups.groups) {
                                                let groupIsClicked = tmpGroupClicked.findIndex(id => id === group.id);
                                                if (groupIsClicked < 0) {
                                                    tmpGroupClicked.push(group.id);
                                                    group.isChecked = true;
                                                }

                                                if (group.rates) {
                                                    for (let rate of group.rates) {
                                                        let rateIsClicked = tmpRatesClicked.findIndex(id => id === rate.id);
                                                        if (rateIsClicked < 0) {
                                                            tmpRatesClicked.push(rate.id);
                                                            rate.isChecked = true;
                                                        }
                                                    }
                                                }
                                            }
                                        }

                                        if (ratesAndGroups.rates) {
                                            // Iteration rates
                                            for (let rate of ratesAndGroups.rates) {
                                                let rateIsClicked = tmpRatesClicked.findIndex(id => id === rate.id);
                                                if (rateIsClicked < 0) {
                                                    tmpRatesClicked.push(rate.id);
                                                    rate.isChecked = true;
                                                }
                                            }
                                        }
                                    }

                                    setGroupClicked(tmpGroupClicked);
                                    setRatesClicked(tmpRatesClicked);
                                }}
                                label={t('ticket.widget.form.allEventChoice')}
                            />
                        </Form.Field>
                    </Grid.Row>
                </Grid>
            </Segment>
        );
    };

    const ratesWithoutGroupMapping = rates => {
        if (!rates) {
            return;
        }
        return rates.map(rate => {
            return (
                <Grid key={rate.id}>
                    <Grid.Row style={{ marginLeft: '1em' }}>
                        <Checkbox checked={rate.isChecked} value={rate.id} onChange={onClickRate} label={rate.resolved_name} />
                    </Grid.Row>
                    <Divider fitted style={{ marginBottom: '0px', marginTop: '0px' }} />
                </Grid>
            );
        });
    };

    return (
        <div>
            <Form.Field>
                <label>
                    <Trans i18nKey="ticket.widget.singleEvent.titleRate">Select your rates</Trans>
                </label>
            </Form.Field>
            <Segment.Group style={{ marginBottom: '14px' }}>
                <Segment
                    onClick={() => {
                        setDisplayAllRates(!displayAllRates);
                    }}
                    style={{ cursor: 'pointer' }}
                >
                    {displayAllRates ? (
                        <span>
                            <Icon className="angle down" />
                            <label>
                                <Trans i18nKey="ticket.widget.singleEvent.placeholderRateMinus">Click to close rates</Trans>
                            </label>
                        </span>
                    ) : (
                        <span>
                            <Icon className="angle right" />
                            <label>
                                <Trans i18nKey="ticket.widget.singleEvent.placeholderRatePlus">Click to select rates</Trans>
                            </label>
                        </span>
                    )}
                </Segment>

                {displayAllRates ? selectAllButton(ratesAndGroups, form, setForm, groupClicked, setGroupClicked, rateClicked, setRateClicked) : null}

                {displayAllRates ? (
                    <Segment>
                        {groupMapping(ratesAndGroups.groups)}
                        {ratesWithoutGroupMapping(ratesAndGroups.rates)}
                    </Segment>
                ) : null}
            </Segment.Group>
        </div>
    );
}
RateSelector.propTypes = {
    ratesAndGroups: PropTypes.shape.isRequired,
    rateClicked: PropTypes.array.isRequired,
    setRateClicked: PropTypes.func.isRequired,
    setGroupClicked: PropTypes.func.isRequired,
    groupClicked: PropTypes.array.isRequired,
    setForm: PropTypes.func.isRequired,
    form: PropTypes.shape.isRequired
};
